import axios from 'axios';

export function deleteEmailDomain(domainId) {
  return axios
    .delete(`/api/?entity=vessel&action=deleteEmailDomain&domainId=${domainId}`)
    .then(response=> response.data)
    .catch(error => {
        return Promise.reject({code: error.response.status, message: error.response.data.data.message})
    });
}
